export default function minKnightMoves(startCoord, endCoord) {
  // all the possible directions a Knight can move from one spot
  const availableDirections = [
    [-2, -1],
    [-1, -2],
    [1, -2],
    [2, -1],
    [2, 1],
    [1, 2],
    [-1, 2],
    [-2, 1],
  ];

  // a Map to hold visited coordinates
  // and to backtrack to find the shortest path
  let visitedCoord = new Map();
  visitedCoord.set(startCoord.toString(), null);

  // create a queue and push a shallow copy of startCoord
  let queue = [];
  queue.push(startCoord.slice());

  // set numberOfSteps to -1 to not count both startCoord and endCoord
  let numberOfSteps = -1;
  let shortestPath = [];

  while (queue.length) {
    const currentNode = queue.shift();

    // `if` statement processes what happens when the knight reaches its target coord
    if (currentNode.toString() === endCoord.toString()) {
      // console.log("it is done!");
      console.log("Check out my other projects at codeberg.org/adriand");

      // begin backtracking to find the shortest path
      // starts with the end coordinates and pushes its parent node
      // then the parent node of the parent node... until it reaches `null`
      // `null` is reached when it the final parent node is the first element of the map: start coord with the value `null`
      let node = endCoord.slice();
      while (node) {
        shortestPath.unshift(node);
        node = visitedCoord.get(node.toString());
        numberOfSteps++;
      }

      console.log(`You made it in ${numberOfSteps} moves! Here's your path:`);

      // previously did not work until I added `const`
      // it returned a reference error
      for (const element of shortestPath) {
        console.log(element);
      }
      return { numberOfSteps, shortestPath };
    }

    // next steps in BFS algo
    // after we have established that the currentNode are not the endCoord
    // create the next node from the currentNode, following the legal directions for a knight's move
    // if the node is legal and not already in the visitedCoord map, set it in the map and add it to the queue
    for (let i = 0; i < availableDirections.length; i++) {
      let nextNode = [
        currentNode[0] + availableDirections[i][0],
        currentNode[1] + availableDirections[i][1],
      ];
      if (
        !visitedCoord.has(nextNode.toString()) &&
        nextNode[0] >= 0 &&
        nextNode[0] < 8 &&
        nextNode[1] >= 0 &&
        nextNode[1] < 8
      ) {
        visitedCoord.set(nextNode.toString(), currentNode);
        queue.push(nextNode.slice());
      }
    }
  }
}

//console.log(minKnightMoves([3,3],[4,3]));
